import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react'

import { configs } from '../configs'
import { EventAlaskaApiResponse, ExtraAlaskaApiResponse, MasterAlaskaApiResponse } from '../types.alaska'

export const alaskaApi = createApi({
  reducerPath: 'alaskaApi',
  baseQuery: retry(
    fetchBaseQuery({ baseUrl: configs.ATHLINKS_API_HOST }),
    {
      maxRetries: configs.rtkQueryMaxRetries
    }
  ),
  endpoints: (builder) => ({
    getEventCourses: builder.query<any, number>({
      query: (athlinksEventId: number) => `/Events/Race/Api/${athlinksEventId}/Course/0`,
      transformResponse: (resp: any) => resp.Result,
    }),
    getExtraData: builder.query<ExtraAlaskaApiResponse, number>({
      query: (eventId) => `/events/api/${eventId}/extra`,
    }),
    getMasterData: builder.query<MasterAlaskaApiResponse, number>({
      query: (masterId) => `/MasterEvents/Api/${masterId}`,
    }),
    getEventsMergedData: builder.query<EventAlaskaApiResponse, number>({
      query: (eventId) => `/Events/Api/Merged/${eventId}`,
    }),
  }),
})

export const { useGetEventCoursesQuery, useGetExtraDataQuery, useGetMasterDataQuery, useGetEventsMergedDataQuery } = alaskaApi